const pathTitleMap: Record<string, string> = {
  "/login": "Login",
  "/signup": "Sign Up",
  "/forgetpassword": "Forget Password",
  "/confirm": "Email Confirmation",
  "/join": "Invite User",
  "/resetpassword": "Reset Password",
  "/privacy-policy": "Privacy Policy",
  "/subscription": "Subscription Plans",
  "/": "Dashboard",
  "/chats": "Chats",
  "/users": "Users",
  "/reports": "Reports",
  "/settings": "Settings",
  "/settings/facebook": "Facebook Settings",
  "/settings/instagram": "Instagram Settings",
  "/settings/whatsapp": "WhatsApp Settings",
  "/settings/twilio": "Twilio Settings",
  "/settings/canned-response": "Canned Responses",
  "/settings/label": "Label Settings",
  "/settings/profile": "Profile Settings",
  "/settings/upgrade-plan": "Upgrade Plan",
  "/settings/billing": "Billing",
};
export default pathTitleMap;
